import { SETTINGS_ANCHORS, SETTINGS_CONTEXTS } from './anchors'
import { SHARED_ANCHORS } from '../shared/anchors'
import { withScopes } from '../shared/scopes'
import type { IOnboardingScenario } from '../../types/IOnboardingScenario'
import type { IOnboardingStep } from '../../types/IOnboardingStep'

const { toolbar, tabs, organization } = SETTINGS_ANCHORS
const ctx = SETTINGS_CONTEXTS

/* Демо-данных нет: сценарий проходит по полям и кнопкам страницы, упор — на условия включения «Обращений граждан» */
const steps: IOnboardingStep[] = [
  { id: 'settings.intro', anchors: [], context: ctx.page },
  { id: 'settings.noOrganization', anchors: [], context: ctx.page, condition: 'settings.cannotEditOrganization' },
  { id: 'settings.tabs.organization', anchors: [tabs.organization], context: ctx.page, condition: 'settings.canEditOrganization', placement: 'bottom' },
  ...withScopes(['organizationTab'], [
    { id: 'settings.requisites', anchors: [organization.requisitesFirst, organization.requisitesLast], context: ctx.page, condition: 'settings.canEditOrganization', placement: 'auto' },
    { id: 'settings.email', anchors: [organization.email], context: ctx.page, condition: 'settings.canEditOrganization', placement: 'auto' },
    { id: 'settings.documents', anchors: [organization.documentsFirst, organization.agreementLast],context: ctx.page, condition: 'settings.canEditOrganization', placement: 'auto' },
    { id: 'settings.consent', anchors: [organization.consent], context: ctx.page, condition: 'settings.canEditOrganization', placement: 'auto' },
    { id: 'settings.agreement', anchors: [organization.agreementFirst, organization.agreementLast],context: ctx.page, condition: 'settings.canEditOrganization', placement: 'auto' },
    { id: 'settings.save', anchors: [toolbar.save], context: ctx.page, condition: 'settings.canEditOrganization', placement: 'bottom' },
    { id: 'settings.importNorms', anchors: [toolbar.importNorms], context: ctx.page, condition: 'settings.canImportNorms', placement: 'bottom' },
  ]),
  { id: 'settings.tabs.structure', anchors: [tabs.structure], context: ctx.page, condition: 'settings.canEditStructure', placement: 'bottom' },
  ...withScopes(['structureTab'], [
    { id: 'settings.importLocations', anchors: [toolbar.importLocations], context: ctx.page, condition: 'settings.canEditStructure', placement: 'bottom' },
  ]),
  { id: 'settings.tabs.branding', anchors: [tabs.branding], context: ctx.page, condition: 'settings.canEditOrganization', placement: 'bottom' },
  { id: 'settings.tabs.integrations', anchors: [tabs.integrations], context: ctx.page, condition: 'settings.canManageIntegrations', placement: 'bottom' },
  { id: 'toolbar.onboarding', anchors: [SHARED_ANCHORS.toolbar.onboarding], context: ctx.page },
]

export const settingsScenarios: IOnboardingScenario[] = [
  {
    id: 'settings',
    section: 'settings',
    isMain: true,
    scopes: {
      organizationTab: {
        open: { context: ctx.page, action: 'showOrganizationTab' },
        close: { context: ctx.page, action: 'restoreTab' },
      },
      structureTab: {
        open: { context: ctx.page, action: 'showStructureTab' },
        close: { context: ctx.page, action: 'restoreTab' },
      },
    },
    steps,
  },
]
